export default __webpack_public_path__ + "static/media/jf-openhuninn-1.1.eaf7c8f5.ttf";